import { Carousel } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import CandidateApplicants from "@/assets/images/OurServices/CandidateApplicants.png";
import CandidateContactDetails from "@/assets/images/OurServices/CandidateContactDetails.png";
import ClientPortalChat from "@/assets/images/OurServices/ClientPortalChat.png";
import InvitedClinicians from "@/assets/images/OurServices/InvitedClinicians.png";
import PostAJob from "@/assets/images/OurServices/PostAJob.png";
import QRCode from "@/assets/images/OurServices/QRCode.png";
import RunningLate from "@/assets/images/OurServices/RunningLate.png";
import ModalPopUp from "@/Components/common/ModalPopUp";
import ApplocumLogoIcon from "@/Components/Icons/ApplocumLogoIcon";
import BagIcon from "@/Components/Icons/BagIcon";
import { InvitedIcon } from "@/Components/Icons/candidateType/InvitedIcon";
import { DocumentIcon } from "@/Components/Icons/DocumentIcon";
import MessageIcon from "@/Components/Icons/MessageIcon";
import PersonIcon from "@/Components/Icons/PersonIcon";
import QrCodeIcon from "@/Components/Icons/QrCodeIcon";
import { RejectIcon } from "@/Components/Icons/RejectIcon";
import RunningLateIcon from "@/Components/Icons/RunningLateIcon";
import { toggleOurServiceModal } from "@/reducers/clientcommon";

const OurServicesModal = () => {
  const { showOurServiceModal } = useSelector((state) => state.clientCommon);
  const dispatch = useDispatch();
  const [activeImage, setActiveImage] = useState(0);
  useEffect(() => {
    if (showOurServiceModal) {
      setActiveImage(0);
    }
  }, [showOurServiceModal]);
  const data = [
    {
      icon: <MessageIcon cls={"w-[18px] h-[18px]"} />,
      title:
        "Client Portal Chat - advanced functions - group messaging and configurable templates",
      desc: "Advance features on client portal chat - allows users to easily message multiple candidates and create templates",
      images: ClientPortalChat,
      imageText: "Client Portal Chat",
    },
    {
      icon: <BagIcon cls={"w-[20px] h-[20px]"} />,
      title: "Post a Job - Locum shifts",
      desc: "Self service for clients to be able to publish their own locum shifts at a self service rate compared to the traditional",
      images: PostAJob,
      imageText: "Post a Job - Locum shifts",
    },
    {
      icon: <PersonIcon cls={"w-[22px] h-[22px]"} />,
      title: "Candidate Applicants",
      desc: "Be in control and view all applicants that have applied for shifts at your site. Accept only the candidates you want.",
      images: CandidateApplicants,
      imageText: "Candidate Applicants",
    },
    {
      icon: <DocumentIcon />,
      title: "Candidate Contact Details",
      desc: "View contact details of all clinicians who have applied, booked and worked on your site which gives you ability to call or message them directly if needed.",
      images: CandidateContactDetails,
      imageText: "Candidate Contact Details",
    },
    {
      icon: <RunningLateIcon cls={"w-[24px] h-[24px]"} />,
      title: "Running Late",
      desc: "Be in the know and get alerted instantly if candidates are running late to a shift",
      images: RunningLate,
      imageText: "Running late",
    },
    {
      icon: <QrCodeIcon />,
      title: "QR Code",
      desc: "Real time clock in and clock out functions for all locum staff.",
      images: QRCode,
      imageText: "QR Code",
    },
    {
      icon: <InvitedIcon cls={"h-[22px] w-[22px]"} />,
      title: "Invite your clinicians",
      desc: "Keep your clinicians 100% compliant for CQC.  Use our intuitive invite function to invite your trusted locums and bank staff to your portal. Let AppLocum keep them compliant and you assured!",
      images: InvitedClinicians,
      imageText: "Invite your clinicians",
    },
    // {
    //   icon: <DownloadIcon />,
    //   title: "Batch downloading of Compliance Files",
    //   desc: "Download full compliance files for candidates with one click",
    // },
  ];
  const handleClose = () => {
    dispatch(toggleOurServiceModal(false));
  };
  const carouselRef = React.createRef();
  const handleClick = (index) => {
    setActiveImage(index);
    carouselRef.current.goTo(index);
  };
  return (
    <ModalPopUp
      show={showOurServiceModal}
      panelClass="max-w-[1200px] !p-0 overflow-hidden"
      onClose={() => {
        handleClose();
      }}
      panelContainerClass="2xl:flex 2xl:justify-center 2xl:items-center"
    >
      <div className="grid grid-cols-1 gap-0 sm:grid-cols-2">
        <div className="bg-white p-5">
          <div className="flex flex-col gap-6">
            <h3 className="text-[22px] font-bold leading-[normal] text-black">
              Our Services
            </h3>
            <div className="flex flex-col gap-5">
              {data.map((ele, index) => {
                return (
                  <div
                    className="flex cursor-pointer gap-[14.95px]"
                    key={index}
                    onClick={() => {
                      handleClick(index);
                    }}
                  >
                    <div
                      className={`flex h-[37px] w-[37px] min-w-[37px] items-center justify-center rounded-[5.61px] transition-all duration-200 ease-linear ${activeImage == index ? "bg-primary text-lightblue" : "bg-lightblue text-primary"}`}
                    >
                      {ele.icon}
                    </div>
                    <div>
                      <h2 className="text-[16px] font-bold text-black">
                        {ele.title}
                      </h2>
                      <p className="text-[13px] font-medium text-black">
                        {ele.desc}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="flex justify-center pt-[5px]">
              <a
                className="transition-linear flex h-[37px] w-[159px] items-center justify-center rounded-lg border border-primary bg-primary text-[13px] font-medium text-white hover:bg-white hover:text-primary"
                href="mailto:hello@applocum.com"
                target="_blank"
                rel="noreferrer"
              >
                Contact Us
              </a>
            </div>
          </div>
        </div>
        <div className="relative flex flex-col bg-primary p-[24px_9px_24px_9px]">
          <ApplocumLogoIcon cls="absolute right-0 top-0 h-full opacity-[0.5] text-lightblue z-0" />
          <div className="relative z-20 flex justify-end pr-[15px]">
            <button
              onClick={() => {
                handleClose();
              }}
              className="text-white outline-none ring-0"
            >
              <RejectIcon cls="w-[37px] h-[37px]" />
            </button>
          </div>
          <div className="OurServicesModal_Images relative grow">
            <div className="absolute left-0 top-[calc(50%-18px)] w-full -translate-y-1/2">
              <Carousel
                autoplay
                beforeChange={(from, to) => setActiveImage(to)}
                ref={carouselRef}
              >
                {data.map((ele, index) => {
                  return (
                    <div
                      className="!flex flex-col items-center justify-center gap-6"
                      key={index}
                    >
                      <h4 className="text-center text-[24px] font-semibold text-white">
                        {ele.imageText}
                      </h4>
                      <img
                        src={ele.images}
                        alt={ele.imageText}
                        className="w-full rounded-lg border-2 border-black"
                      />
                    </div>
                  );
                })}
              </Carousel>
            </div>
          </div>
        </div>
      </div>
    </ModalPopUp>
  );
};

export default OurServicesModal;
